<nav class="wrapper">
  <div class="left">
    <div class="gradient-bar"></div>
    <a class="logo" routerLink="/home">
      <img src="./assets/images/actabl-white.png" alt="Actabl" class="actabl" />
    </a>
  </div>
  <div class="right">
    @if (isMobile) {
    <app-sidebar
      [name]="name"
      [email]="email"
      [navMenuItems]="navMenuItems"
      [dropdownItems]="dropdownItems"
    ></app-sidebar>
    } @else {
    <app-dropdown
      [name]="name"
      [email]="email"
      [navMenuItems]="navMenuItems"
      [dropdownItems]="dropdownItems"
    ></app-dropdown>
    }
  </div>
</nav>
